import { FC, ReactNode } from "react";
import {
  Box,
  FormControl,
  Input,
  InputLabel,
  InputProps,
} from "@material-ui/core";
import { Help as HelpIcon } from "@material-ui/icons";

import { Tooltip } from "components";
import { FormHelperTextExtra } from "components/FormHelperText";

interface LabelFieldProps {
  label: string | number;
  value: string | number;
  tooltipText?: string | ReactNode;
  interactiveTooltip?: boolean;
  helperText?: string;
}

const LabelField: FC<LabelFieldProps & InputProps> = ({
  label,
  value,
  tooltipText,
  interactiveTooltip,
  helperText,
  ...restProps
}) => (
  <FormControl fullWidth>
    <InputLabel htmlFor={label.toString()} focused={false}>
      <Box display="flex" alignItems="center">
        {label}
        {tooltipText && (
          <Tooltip title={tooltipText} interactive={!!interactiveTooltip}>
            <Box ml={1}>
              <HelpIcon fontSize="small" />
            </Box>
          </Tooltip>
        )}
      </Box>
    </InputLabel>
    <Input
      id={label.toString()}
      value={value}
      disableUnderline
      readOnly
      inputProps={{ style: { paddingBottom: !!helperText ? 0 : "7px" } }}
      {...restProps}
    />
    {helperText && <FormHelperTextExtra>{helperText}</FormHelperTextExtra>}
  </FormControl>
);

export default LabelField;
